export const TipoSolicitacao = {
  VendaConcluida: 'VendaConcluida',
  HomologacaoPrevia: 'HomologacaoPrevia',
} as const;
export type TipoSolicitacao = (typeof TipoSolicitacao)[keyof typeof TipoSolicitacao];

export const TipoEstrutura = {
  Metalico: 'Metalico',
  Ceramico: 'Ceramico',
  Solo: 'Solo',
  Carport: 'Carport',
  Fibrocimento: 'Fibrocimento',
  Fibromadeira: 'Fibromadeira',
  Laje: 'Laje',
} as const;
export type TipoEstrutura = (typeof TipoEstrutura)[keyof typeof TipoEstrutura];

export const TipoPessoa = {
  PF: 'PF',
  PJ: 'PJ',
} as const;
export type TipoPessoa = (typeof TipoPessoa)[keyof typeof TipoPessoa];

export const TipoLocalizacao = {
  Urbana: 'urbana',
  Rural: 'rural',
} as const;
export type TipoLocalizacao = (typeof TipoLocalizacao)[keyof typeof TipoLocalizacao];

export const TipoPadrao = {
  Individual: 'Individual',
  Coletivo: 'Coletivo',
} as const;
export type TipoPadrao = (typeof TipoPadrao)[keyof typeof TipoPadrao];

export const FasesDisjuntor = {
  Monofasico: 'Monofasico',
  Bifasico: 'Bifasico',
  Trifasico: 'Trifasico',
} as const;
export type FasesDisjuntor = (typeof FasesDisjuntor)[keyof typeof FasesDisjuntor];

export const StatusEnvio = {
  Rascunho: 'rascunho',
  Enviado: 'enviado',
  EmAnalise: 'em_analise',
  Aprovado: 'aprovado',
  Reprovado: 'reprovado',
} as const;
export type StatusEnvio = (typeof StatusEnvio)[keyof typeof StatusEnvio];

export const ModoPagamento = {
  Avista: 'avista',
  ParceladoLocal: 'parcelado_local',
  ParceladoRemoto: 'parcelado_remoto',
} as const;
export type ModoPagamento = (typeof ModoPagamento)[keyof typeof ModoPagamento];

export const ContasTitular = {
  Sim: 'Sim',
  Nao: 'Nao',
} as const;
export type ContasTitular = (typeof ContasTitular)[keyof typeof ContasTitular];

export const AcaoHistorico = {
  Criado: 'criado',
  Atualizado: 'atualizado',
  Enviado: 'enviado',
  Aprovado: 'aprovado',
  Reprovado: 'reprovado',
} as const;
export type AcaoHistorico = (typeof AcaoHistorico)[keyof typeof AcaoHistorico];

export const CategoriaArquivo = {
  ComprovanteEnderecoFaturamento: 'comprovante_endereco_faturamento',
  ComprovanteEnderecoInstalacao: 'comprovante_endereco_instalacao',
  DocumentoIdentidade: 'documento_identidade',
  FotosPadrao: 'fotos_padrao',
  ImagensDiversasPadrao: 'imagens_diversas_padrao',
  FotosPadraoColetivo: 'fotos_padrao_coletivo',
  FotoTelhado: 'foto_telhado',
  FotoEstruturaAbaixoTelhado: 'foto_estrutura_abaixo_telhado',
  FotoFachada: 'foto_fachada',
  FotoLocalInversor: 'foto_local_inversor',
  FotoAcessoTelhado: 'foto_acesso_telhado',
  FotoPadraoExemplo: 'foto_padrao_exemplo',
  FotoQuadroConexao: 'foto_quadro_conexao',
  FotoQuadroPassagem: 'foto_quadro_passagem',
  PrintLocalizacao: 'print_localizacao',
  PrintTransformador: 'print_transformador',
  FotoMaterialUsinaExistente: 'foto_material_usina_existente',
  FotoRelacaoCaixas: 'foto_relacao_caixas',
} as const;
export type CategoriaArquivo = (typeof CategoriaArquivo)[keyof typeof CategoriaArquivo];

export const MODALIDADES_COMPENSACAO = [
  'Autoconsumo Local',
  'Autoconsumo Remoto',
  'Geração Compartilhada',
  'Múltiplas Unidades Consumidoras',
] as const;

export const ORIGENS_LEAD = [
  'Pré Vendas',
  'Indicação',
  'Marketing Digital',
  'Loja Física',
  'Parceiro',
  'Outro',
] as const;
